module.exports = __webpack_public_path__ + "media/besofen_1.e781ee89.mp4";